export default "__VITE_ASSET__DwVii7aG__"